import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 276px;
    margin: 0 auto 20px;
    
    .multi-select {
        margin-top: 20px;
    }
    .dropdown-content {
        z-index: 99;
    }
`;